import React from "react"
import { graphql } from "gatsby"
import Layout from "./layout"




const IndexPage = ({ data }) => {


return (

    <Layout>
        <h1><p>Readings</p></h1>
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <a href={node.frontmatter.title} key={node.id} className="rbox" >
              <h1 dangerouslySetInnerHTML={{ __html: node.html }}></h1>
              <h5>{node.frontmatter.date}</h5>
          </a>
        
        ))}

    </Layout>
  )
}

export default IndexPage


        // sort: { fields: [frontmatter___date], order:DESC} 


export const query = graphql`
  query {
    allMarkdownRemark(filter: {
      fileAbsolutePath: {regex: "/wam1f24/_readings/.*.md$/"}}
      ) {
      totalCount
      edges {
        node {
          html
          id
          frontmatter {
            title
            date
          }
        }
      }
    }
  }
`